export const SOURCE_LANGUAGE_BUCKETS = [
  "ru",
  "ro",
  "uk",
  "en",
  "other",
] as const;

export type SourceLanguageBucket =
  (typeof SOURCE_LANGUAGE_BUCKETS)[number];

const SOURCE_LANGUAGE_BUCKET_SET = new Set<string>(SOURCE_LANGUAGE_BUCKETS);

export function baseLanguageCode(value: unknown): string | null {
  if (typeof value !== "string") {
    return null;
  }
  const normalized = value.trim().toLocaleLowerCase();
  if (!normalized) {
    return null;
  }
  return normalized.split(/[-_]/, 1)[0] || null;
}

export function normalizeSourceLanguageBucket(
  value: unknown,
): SourceLanguageBucket | null {
  return typeof value === "string" && SOURCE_LANGUAGE_BUCKET_SET.has(value)
    ? (value as SourceLanguageBucket)
    : null;
}

/**
 * Reduces a raw BCP-47-ish language code to the only value allowed to leave
 * the client or be persisted. Empty/missing values stay unknown and are not
 * silently counted as `other`.
 */
export function sourceLanguageBucket(
  value: unknown,
): SourceLanguageBucket | null {
  const language = baseLanguageCode(value);
  if (!language) {
    return null;
  }
  return normalizeSourceLanguageBucket(language) ?? "other";
}
